import { ESTRATEGIA_RETRY_PADRAO, FalhaHttp, type ClienteHttp, type RespostaHttp } from '@next/infraestrutura/http'
import type { OpcaoPerfilDePermissao } from '../catalogo-perfil-de-permissao.tipos'

const ENDPOINT = '/rolegroup'
const ehRegistro = (valor: unknown): valor is Record<string, unknown> => typeof valor === 'object' && valor !== null && !Array.isArray(valor)
const selecionarCampos = (valor: Record<string, unknown>, campos: readonly string[]): Record<string, unknown> => Object.fromEntries(campos.filter(campo => campo in valor).map(campo => [campo, valor[campo]]))
const projetar = (valor: Record<string, unknown>): OpcaoPerfilDePermissao => {
  const resultado = selecionarCampos(valor, ['id', 'name', 'description', 'kind'])
  return resultado as OpcaoPerfilDePermissao
}
const falhaInvalida = (resposta: RespostaHttp<unknown>): FalhaHttp => new FalhaHttp({
  tipo: 'resposta_invalida', servico: 'condominio', metodo: 'GET', endpoint: ENDPOINT,
  status: resposta.status, causa: resposta.data,
  ...(resposta.requestId ? { requestId: resposta.requestId } : {}),
})

export class ListarOpcoesPerfilDePermissaoRepositorioHttp {
  constructor(private readonly http: ClienteHttp) {}
  executar = async (sinal: AbortSignal): Promise<readonly OpcaoPerfilDePermissao[]> => {
    const resposta = await this.http.get<unknown>(ENDPOINT, { parametros: { fields: JSON.stringify(['name', 'id', 'kind', 'description']) }, signal: sinal, retry: ESTRATEGIA_RETRY_PADRAO })
    if (resposta.status === 204 || (ehRegistro(resposta.data) && 'no-data' in resposta.data)) return []
    if (!ehRegistro(resposta.data) || !Array.isArray(resposta.data.success)) throw falhaInvalida(resposta)
    return resposta.data.success.filter(ehRegistro).map(projetar)
  }
}
